import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CONFIG } from '../constants/config.constants';

import * as Moment from 'moment';

class NgBootstrapDateFormatterFactory extends NgbDateParserFormatter {
    dateFormat = CONFIG.dateFormat;

    constructor() {
        super();
    };

    format(date: NgbDateStruct): string {
        if (date === null) {
            return '';
        }

        const d = Moment({
            year: date.year,
            month: date.month - 1,
            date: date.day
        });

        return d.isValid() ? d.format(this.dateFormat) : '';
    }

    parse(value: string): NgbDateStruct {
        if (!value) {
            return null;
        }

        const d = Moment(value, this.dateFormat, true);

        return d.isValid() ? {
            year: d.year(),
            month: d.month() + 1,
            day: d.date()
        } : null;
    }
}

export function ngBootstrapDateFormatterFactory() {
    return new NgBootstrapDateFormatterFactory();
}
